import React from 'react';
import { Outlet, Link, useLocation } from 'react-router-dom';
import '../styles/Dashboard.css';

function Dashboard({ user, onLogout }) {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  return (
    <div className="dashboard">
      <nav className="sidebar">
        <div className="sidebar-brand">
          <img src="/asterina.png" alt="Asterina" className="asterina-logo-sidebar" />
          <div className="sidebar-brand-text">
            <span className="sidebar-brand-title">Planning Plongée</span>
            <span className="sidebar-brand-sub">{user?.name || user?.username}</span>
          </div>
        </div>

        <ul className="nav-menu">
          <li>
            <Link
              to="/"
              className={isActive('/') && !isActive('/sessions') && !isActive('/settings') ? 'active' : ''}
            >
              <i className="fas fa-home"></i>
              Accueil
            </Link>
          </li>
          <li>
            <Link
              to="/sessions"
              className={isActive('/sessions') ? 'active' : ''}
            >
              <i className="fas fa-calendar-alt"></i>
              Sessions
            </Link>
          </li>
          <li>
            <Link
              to="/settings"
              className={isActive('/settings') ? 'active' : ''}
            >
              <i className="fas fa-cog"></i>
              Paramètres
            </Link>
          </li>
        </ul>

        <div className="sidebar-footer">
          <button onClick={onLogout} className="logout-button">
            <i className="fas fa-sign-out-alt"></i>
            Déconnexion
          </button>
        </div>
      </nav>

      <main className="main-content">
        <Outlet />
      </main>
    </div>
  );
}

export default Dashboard;
